module.exports = __webpack_public_path__ + "static/media/Peter Maxfield.330dbee5.png";